import styled from "styled-components";

export const TransitionCarouselWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
`;
